import {z} from 'zod';

import {ServiceVehicle, ServiceVehicleValidationSchema} from '@dms/features/vehicle-forms-kit';
import type {FieldAvailabilityContext, useMandatoryFields} from '@dms/shared';

const vehicleContextSchema = ServiceVehicleValidationSchema.pick({
  type: true,
  fuelType: true,
  hybridType: true,
}).partial();

export function getServiceVehicleFieldAvailabilityContext(
  values: Partial<Pick<ServiceVehicle, 'type' | 'fuelType' | 'hybridType'>>
): FieldAvailabilityContext {
  return {
    vehicleType: values.type?.at(0),
    fuelType: values.fuelType?.at(0),
    hybridType: values.hybridType?.at(0),
  };
}

export function getServiceVehicleMandatorySchema(
  generateSchema: ReturnType<typeof useMandatoryFields>['generateSchema']
): z.ZodSchema<ServiceVehicle> {
  const inputDrivenSchema = z.unknown().transform((input, context) => {
    const selectedValues = vehicleContextSchema.safeParse(input);
    const fieldContext = selectedValues.success
      ? getServiceVehicleFieldAvailabilityContext(selectedValues.data)
      : {};
    const result = generateSchema(ServiceVehicleValidationSchema, fieldContext).safeParse(input);

    if (!result.success) {
      result.error.issues.forEach((issue) => context.addIssue(issue));
      return z.NEVER;
    }

    return result.data;
  });

  return ServiceVehicleValidationSchema.and(inputDrivenSchema);
}
